import { supabase } from '@/lib/supabase';

export type AgreementTemplate = {
  id: string;
  name: string;
  category: string;
  template_text: string;
};

/** forMultiParty=true φέρνει τα πρότυπα φτιαγμένα για συμφωνίες 3+ ατόμων (πληθυντικός/party_list), false τα κλασικά 2 ατόμων. */
export async function listAgreementTemplates(forMultiParty = false): Promise<AgreementTemplate[]> {
  const { data, error } = await supabase
    .from('agreement_templates')
    .select('id, name, category, template_text')
    .eq('for_multi_party', forMultiParty)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return (data ?? []) as AgreementTemplate[];
}

export type TemplateFields = {
  counterparty_name?: string | null;
  amount?: string | null;
  professional_name?: string | null;
  business_name?: string | null;
  /** Λίστα ονομάτων όλων των συμβαλλομένων, π.χ. "Α, Β και Γ" — μόνο για πρότυπα 3+ ατόμων. */
  party_list?: string | null;
  /** Η πρόταση "...ανέγνωσε τους όρους της επιχείρησης Χ" — κενό όταν ο
   * δημιουργός δεν είναι επαγγελματίας με ενεργό προφίλ. */
  business_terms_clause?: string | null;
};

/** Αντικαθιστά τα {{placeholders}} ενός προτύπου με πραγματικά στοιχεία. Άγνωστο/κενό πεδίο μένει ως κενό string. */
export function fillTemplate(templateText: string, fields: TemplateFields): string {
  const filled = templateText.replace(/\{\{(\w+)\}\}/g, (_match, key: string) => {
    const value = (fields as Record<string, string | null | undefined>)[key];
    return value?.trim() || '';
  });
  // Αν η τιμή ενός placeholder έληγε ήδη σε τελεία (π.χ. "Α.Ε."), απόφυγε διπλή τελεία.
  return filled.replace(/\.{2,}/g, '.');
}
